import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "Telegram VIP grubunda neler paylaşılıyor?",
    a: "VIP grupta günlük fırsat hisseler, piyasa yorumları, kısa & orta vadeli özel analizler, hedef–stop seviyeleri ve takip listeleri paylaşılmaktadır. Tüm paylaşımlar genel bilgilendirme amacı taşır.",
  },
  {
    q: "Günlük hisse fırsatları ne sıklıkla paylaşılır?",
    a: "Piyasa koşullarına göre her işlem günü düzenli paylaşımlar yapılır. Olağanüstü piyasa hareketlerinde ek bilgilendirmeler de gönderilebilir.",
  },
  {
    q: "Paylaşımlar yatırım tavsiyesi midir?",
    a: "Hayır. Burada ve VIP grupta yer alan tüm içerikler genel bilgilendirme amacı taşır. Yatırım tavsiyesi niteliği taşımaz. Yatırım kararlarınızı kendi araştırmanız ve risk profiliniz doğrultusunda vermelisiniz.",
  },
  {
    q: "Derya Eliz Yıldız kimdir?",
    a: "Ankara Çankaya doğumlu, yaklaşık 6 yıldır borsa ve finans piyasalarıyla ilgilenen, piyasa hareketlerini yakından takip eden ve yatırımcılara bilgilendirici içerikler sunan bir isimdir.",
  },
  {
    q: "Borsa bilgilendirmeleri kimler için uygundur?",
    a: "Piyasaları daha bilinçli takip etmek isteyen, kendi araştırmasını yapan ve risk yönetimi farkındalığına sahip tüm yatırımcılar için uygundur. Yatırım kararı vermeden önce mutlaka kendi araştırmanızı yapın.",
  },
];

export default function FAQ() {
  return (
    <section
      id="sss"
      className="relative py-24 md:py-32"
      data-testid="faq-section"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="text-center max-w-2xl mx-auto">
          <span
            className="section-eyebrow inline-block"
            data-testid="faq-eyebrow"
          >
            Sık Sorulan Sorular
          </span>
          <h2
            className="font-serif text-white text-[clamp(2rem,4.6vw,3.75rem)] leading-[1.08] mt-3"
            data-testid="faq-title"
          >
            Aklındaki sorular,
            <br />
            <span className="italic text-gold-gradient">net yanıtlar.</span>
          </h2>
        </div>

        <div className="mt-14">
          <Accordion
            type="single"
            collapsible
            className="space-y-3"
            data-testid="faq-accordion"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="glass-card rounded-xl px-6 border-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left text-white font-serif text-lg md:text-xl hover:no-underline hover:text-[#d4af37] py-6 transition-colors"
                  data-testid={`faq-trigger-${i}`}
                >
                  <span className="flex items-start gap-4">
                    <span className="font-sans text-[#d4af37] text-sm tracking-widest pt-1">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  className="text-[#cbd5e1] text-[15px] font-light leading-relaxed pb-6 pl-10 pr-2"
                  data-testid={`faq-content-${i}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
